import "../style/home.css";
import HeroSection from "../components/HeroSection";
import Footer from "../components/Footer";
import WebsiteNavbar from "../components/WebsiteNavbar";
import StatsSection from "../components/StatsSection";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import PromoBanner from "../components/PromoBanner"; // ← NEW
import BinCard from "../components/BinCard"; // ← NEW
const Home = () => {
  return (
    <>
      <WebsiteNavbar />

      <HeroSection />

      <WhyChooseUs />
<div className="home-bins" id="bins-section">
  <BinCard />
</div>
      <PromoBanner />

      <Testimonials />

      <StatsSection />

      <Footer />
    </>
  );
};

export default Home;
